import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-canal-donation.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetCanalDonationDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metCanalDonationEntity = useAppSelector(state => state.metCanalDonation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metCanalDonationDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metCanalDonation.detail.title">MetCanalDonation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metCanalDonationEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metCanalDonation.code">Code</Translate>
            </span>
          </dt>
          <dd>{metCanalDonationEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metCanalDonation.name">Name</Translate>
            </span>
          </dt>
          <dd>{metCanalDonationEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metCanalDonation.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{metCanalDonationEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metCanalDonation.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{metCanalDonationEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metCanalDonation.status">Status</Translate>
            </span>
          </dt>
          <dd>{metCanalDonationEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-canal-donation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-canal-donation/${metCanalDonationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetCanalDonationDetail;
